// @flow

import Notifications from '../constants/Notifications';
import CarouselSliderButton from './CarouselSliderButton';

export default class CarouselSliderNavigate extends CarouselSliderButton {
  #children: number = 0;
  hiddenClass: string = 'hide';

  /**
   * Instantiate the component
   */
  bind(pEl: HTMLElement): void {
    super.bind(pEl);

    if (this.isPreviousButton()) {
      pEl.classList.add(this.hiddenClass);
    }

    this.addListener(Notifications.CAROUSEL_CHANGE_INDEX, this.handleChangeIndex);
    this.addListener(Notifications.CAROUSEL_UPDATE_NAVIGATION, this.handleChangeIndex);
    this.addListener(Notifications.CAROUSEL_CHILDREN_UPDATE, this.handleCarouselChildrenUpdates);
  }

  /**
   * Executes when the component is clicked
   */
  handleClickEvents(e: Event) {
    e.preventDefault();

    this.notify(Notifications.RESET_ZOOM);

    if (this.isNextButton() && ((this.index + 1) <= this.#children)) {
      this.notify(Notifications.CAROUSEL_CHANGE_INDEX, { index: this.index + 1 });
    } else {
      if (this.isPreviousButton() && ((this.index - 1) >= 0)) {
        this.notify(Notifications.CAROUSEL_CHANGE_INDEX, { index: this.index - 1 });
      }
    }
  }

  /**
   * Executes when the slider has changed its index
   */
  handleChangeIndex({ index }: { index: number }) {
    if ((index >= 0) && (index <= this.#children)) {
      this.index = index;
      if ((index === 0) && this.isPreviousButton()) {
        this.el.classList.add(this.hiddenClass);
      } else if ((index === this.#children) && this.isNextButton()) {
        this.el.classList.add(this.hiddenClass);
      } else {
        this.el.classList.remove(this.hiddenClass);
      }
    }
  }

  /**
   * Executes when the slider is updated
   */
  handleCarouselChildrenUpdates({ count }: { count: number }) {
    this.#children = count;
  }

  /**
   * Check if the component is a previous button
   */
  isPreviousButton(): boolean {
    return this.el.dataset.previous !== undefined;
  }

  /**
   * Check if the component is a next button
   */
  isNextButton(): boolean {
    return this.el.dataset.next !== undefined;
  }
}
